import { FilePlus2, Gauge, ListChecks } from "lucide-react";
import { ConsoleShell } from "@/pages/portal/PortalLayout";
import { useInsurer } from "@/context/InsurerContext";
import { insTone, INS_STATUS_LABEL } from "@/lib/insurance";

const NAV = [
  ["dashboard", "Dashboard", Gauge, "/insurer"],
  ["new-request", "New Request", FilePlus2, "/insurer/request/new"],
  ["requests", "My Requests", ListChecks, "/insurer/requests"],
];

export const InsStatus = ({ status, testId }) => (
  <span data-testid={testId} className={`inline-flex rounded-full px-2.5 py-0.5 text-[11px] font-semibold whitespace-nowrap ${insTone(status)}`}>
    {INS_STATUS_LABEL[status] || status}
  </span>
);

export default function InsurerLayout() {
  const { insurer, logout } = useInsurer();
  const account = { name: insurer?.company_name, email: insurer?.email };
  return <ConsoleShell nav={NAV} title="Insurer" testPrefix="insurer" account={account} onLogout={logout} />;
}
